module.exports = __webpack_public_path__ + "static/media/vcc-exchange.e2fa161f.png";